import React, { useState } from "react";
import {
  IconSquareFilled,
  IconPhoto,
  IconWallpaper,
  IconView360,
  IconLayoutGrid,
} from '@tabler/icons-react';
import { useObjectStore } from "../zustand/objects";
import { Menu, ActionIcon } from '@mantine/core';


import { nanoid } from 'nanoid'

import ModelPoses from '../ModelPoses.json';
import { leftNavMenuProps } from "../styleFile";
import { VIEWPORT_DEFAULT_FLOOR_HEX } from "../utils/viewportCanvasDefaults";

const AppleIcon = () => {
  return (
    <svg fill="currentColor" width="20px" height="20px" viewBox="-3.5 -2 24 24" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMinYMin" className="jam jam-apple"><path d='M13.623 10.627c-.025-2.533 2.066-3.748 2.159-3.808-1.175-1.72-3.005-1.955-3.657-1.982-1.557-.158-3.039.917-3.83.917-.788 0-2.008-.894-3.3-.87C3.299 4.909 1.734 5.87.86 7.39c-1.764 3.06-.452 7.595 1.267 10.077.84 1.215 1.842 2.58 3.157 2.53 1.266-.05 1.745-.819 3.276-.819 1.531 0 1.962.82 3.302.795 1.363-.026 2.226-1.239 3.06-2.457.965-1.41 1.362-2.775 1.386-2.845-.03-.013-2.658-1.02-2.684-4.045zm-2.518-7.433c.698-.847 1.169-2.022 1.04-3.194C11.14.04 9.921.67 9.2 1.515c-.647.75-1.214 1.945-1.062 3.094 1.122.088 2.268-.57 2.967-1.415z' /></svg>
  )
}

const WindowsIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" x="0px" y="0px" width="20px" height="20px" viewBox="0 0 30 30"><path d="M 6 4 C 4.895 4 4 4.895 4 6 L 4 12 C 4 13.105 4.895 14 6 14 L 12 14 C 13.105 14 14 13.105 14 12 L 14 6 C 14 4.895 13.105 4 12 4 L 6 4 z M 18 4 C 16.895 4 16 4.895 16 6 L 16 12 C 16 13.105 16.895 14 18 14 L 24 14 C 25.105 14 26 13.105 26 12 L 26 6 C 26 4.895 25.105 4 24 4 L 18 4 z M 6 16 C 4.895 16 4 16.895 4 18 L 4 24 C 4 25.105 4.895 26 6 26 L 12 26 C 13.105 26 14 25.105 14 24 L 14 18 C 14 16.895 13.105 16 12 16 L 6 16 z M 18 16 C 16.895 16 16 16.895 16 18 L 16 24 C 16 25.105 16.895 26 18 26 L 24 26 C 25.105 26 26 25.105 26 24 L 26 18 C 26 16.895 25.105 16 24 16 L 18 16 z"></path></svg>
  )
}

export const FloorColourButton = () => {

  const colours = [
    { value: 'black', label: 'Black' },
    { value: '#C4A484', label: 'Brown' },
    { value: 'lightBlue', label: 'Light Blue' },
    { value: '#359DED', label: 'Blue' },
    { value: 'lightGreen', label: 'Light Green' },
    { value: '#77D356', label: 'Green' },
    { value: VIEWPORT_DEFAULT_FLOOR_HEX, label: 'Light Grey' },
    { value: 'grey', label: 'Grey' },
    { value: 'orange', label: 'Orange' },
    { value: '#CD303E', label: 'Red' },
    { value: 'violet', label: 'Violet' },
    { value: 'white', label: 'White' },
    { value: '#FAC710', label: 'Yellow' }
  ]

  const { floorColour, objectsAreLoaded, setFloorColour } = useObjectStore();

  const handleSelect = (mapped) => { mapped && setFloorColour(mapped.value) }

  return (

    <Menu transitionProps={{ transition: 'pop' }} withinPortal trigger="hover">
      <Menu.Target>
        <ActionIcon
          variant="transparent"
          color={'black'}
          size={'sm'}
        >
          <div style={{ height: 15, width: 15, backgroundColor: objectsAreLoaded ? floorColour : "white", borderColor: "black", borderStyle: "solid", marginRight: 6, borderRadius: 2 }}></div>
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        {colours.map((mapped, i) => (
          <Menu.Item key={i} value={mapped.value} onClick={() => handleSelect(mapped)}><IconSquareFilled size={18} color={mapped.value} />{mapped.label}</Menu.Item>
        ))}
      </Menu.Dropdown>
    </Menu>
  );
};

export const ImageButton = ({ iconColour, leftNav = false }) => {

  const { addObject, currentObjectArtboard, arrangeUndoRedo } = useObjectStore();

  const [hover, setHover] = useState(false)

  const imageArray = [
    { value: "apple", label: "Apple UI elements", icon: "WallpaperOutlinedIcon fontSize:'small' " },
    { value: "background", label: "Background spaces", icon: "WallpaperOutlinedIcon fontSize:'small' " },
    { value: "floatgridsUi", label: "FloatGrids UI elements", icon: "WallpaperOutlinedIcon fontSize:'small' " },
    { value: "floatgridsLayout", label: "FloatGrids layouts", icon: "WallpaperOutlinedIcon fontSize:'small' " },
    { value: "microsoft", label: "Microsoft UI elements", icon: "WallpaperOutlinedIcon fontSize:'small' " }
  ]



  // FUNCTIONS 
  const handleChange = (e) => {
    const newID = nanoid()
    // send update to zustand first (so we have state to grab for undo array)
    addObject({
      currentObjectArtboard,
      category: e.value,
      object: e.value,
      undo: false,
      id: newID,
      position: null,
      scale: null,
      rotation: null,
      matrix: null,
      pose: {
        name: ModelPoses[e.value] ? ModelPoses[e.value][0] : null,
        modelPath: null
      },
      imageTexture: null,
      image: null,
      curved: false,
      curveAmount: 3,
      bGColour: null
    })
    // send current state to undoActions
    arrangeUndoRedo({
      updateType: "objectAdd",
      artboard: currentObjectArtboard,
      objectID: newID,
      undo: false
    })

  };

  const handleSelect = (e) => handleChange(e)

  return (
    <Menu
      transitionProps={{ transition: 'pop' }}
      withinPortal
      trigger="hover"
      {...(leftNav ? leftNavMenuProps : {})}
    >
      <Menu.Target>
        <ActionIcon
          size={leftNav ? 28 : undefined}
          radius={leftNav ? 12 : undefined}
          variant="transparent"
          color={!hover ? iconColour.normal : iconColour.hover}
          onPointerOver={() => setHover(true)}
          onPointerLeave={() => setHover(false)}
          style={
            leftNav
              ? {
                backgroundColor: hover ? (iconColour?.hoverBg || "#f3f4f6") : "transparent",
                border: hover ? `1px solid ${iconColour?.border || "#e5e7eb"}` : "1px solid transparent",
              }
              : undefined
          }
        >
          <IconPhoto size={18} />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item value="apple" onClick={() => handleSelect(imageArray[0])} leftSection={<AppleIcon fontSize={'small'} />}>Apple UI elements</Menu.Item>
        <Menu.Item value="microsoft" onClick={() => handleSelect(imageArray[4])} leftSection={<WindowsIcon fontSize={'small'} />}>Microsoft UI elements</Menu.Item>
        <Menu.Item value="floatgridsUi" onClick={() => handleSelect(imageArray[2])} leftSection={<IconLayoutGrid size={18} />}>FloatGrids UI elements</Menu.Item>
        <Menu.Item value="floatgridsLayout" onClick={() => handleSelect(imageArray[3])} leftSection={<IconView360 size={18} />}>FloatGrids layouts</Menu.Item>
        <Menu.Item value="background" onClick={() => handleSelect(imageArray[1])} leftSection={<IconWallpaper size={18} />}>Background spaces</Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
};
